

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NewRequestButton extends Vue {
  private onNewRequestClick(): void {
    this.$store.dispatch('addEditRequest/showModal');
  }

}
